import * as buffs from './buffs';
import * as barbarian from './skill_barbarian';
import * as crusader from './skill_crusader';
import * as demonhunter from './skill_demonhunter';
import * as monk from './skill_monk';
import * as necromancer from './skill_necromancer';
import * as witchdoctor from './skill_witchdoctor';
import * as wizard from './skill_wizard';
import { followerSkills } from './skill_follower';

export * from './gems';
export * from './item_special';
export * from './altar';

const classData = {barbarian, crusader, demonhunter, monk, necromancer, witchdoctor, wizard};
const skills = {};
const passives = {};
const extraskills = {};
const partybuffs = {...buffs};

for (const [cls, data] of Object.entries(classData)) {
  skills[cls] = data.skills;
  passives[cls] = data.passives;
  partybuffs[cls] = data.partybuffs;
  if (data.extraskills) {
    extraskills[cls] = data.extraskills;
  }
}

export { skills, passives, partybuffs, extraskills, followerSkills };
